module.exports = __webpack_public_path__ + "img/dingzhi03.19403e20.png";